'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const{TimelineScheduleDirectiveController}=require('../../../../../../dist-es6/client/features/personalSchedule/components/timelineSchedule/timelineScheduleDirective');let

ReportTimelineScheduleDirective=class ReportTimelineScheduleDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'displayTimeZone',
'timezoneDescription',
'timeOfLastHosStatus',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'weekFormatter',
'sleepFormatter',
'personalStatistics'];

}

get templateUrl(){
return'/templates/features/fatigueReport/components/reportTimelineSchedule/reportTimelineScheduleView';
}

get controller(){
return ReportTimelineScheduleDirectiveController;
}};let


ReportTimelineScheduleDirectiveController=class ReportTimelineScheduleDirectiveController extends TimelineScheduleDirectiveController{
constructor($scope,$element,$timeout,displaySettingsService,timeFormattingService){
super($scope,$element,$timeout,displaySettingsService,timeFormattingService);
}

get _shiftDailySummaryColumnsForReport(){
return!0;
}};


module.exports=ReportTimelineScheduleDirective;
//# sourceMappingURL=reportTimelineScheduleDirective.js.map
